// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"5a7233ec","287":"d33b56b3","372":"5158a936","584":"a0daa50e","666":"b6248dfe","672":"0a04932e","809":"3e8fd1fa","818":"a0779f81"}[chunkId] + ".chunk.js";
};